import type { Strings } from './en'

export const pt: Strings = {
  email: 'E-mail',
  password: 'Senha',
  name: 'Nome',
  cancel: 'Cancelar',
  continue: 'Continuar',
  or: 'ou',
  useDifferentEmail: 'Usar outro e-mail',
  somethingWrong: 'Algo deu errado',
  code6: 'Código de 6 dígitos',
  resetCode: 'Código de redefinição',
  newPassword: 'Nova senha',
  continueWithGoogle: 'Continuar com o Google',
  continueWithEmail: 'Continuar com e-mail',
  back: 'Voltar',
  chooserTitle: 'Entre ou crie sua conta',
  chooserSubtitle: 'Escolha como deseja continuar',
  continueWithApple: 'Continuar com a Apple',

  emailTitle: 'Continuar com e-mail',
  emailSubtitle: 'Informe seu e-mail para continuar',
  welcomeBack: 'Bem-vindo de volta',
  signIn: 'Entrar',
  forgotPassword: 'Esqueceu a senha?',
  createTitle: 'Crie sua conta',
  createAccount: 'Criar conta',
  confirmTitle: 'Confirme seu e-mail',
  confirmCta: 'Confirmar e entrar',
  resendCode: 'Reenviar código',
  confirmNeeded: 'Este e-mail precisa de confirmação. Informe o código que enviamos.',
  confirmCodeSent: 'Enviamos um código de 6 dígitos para seu e-mail.',
  codeResent: 'Código reenviado.',
  googleTitle: 'Use o Google para entrar',
  isGoogleAccount: 'é uma conta Google',
  appleTitle: 'Use a Apple para entrar',
  isAppleAccount: 'é uma conta Apple',
  googleNotConfigured: 'O login com Google não está configurado',
  resetTitle: 'Redefina sua senha',
  resetSubtitle: 'Enviaremos um código por e-mail',
  sendResetCode: 'Enviar código',
  resetCodeSent: 'Enviamos um código de redefinição por e-mail.',
  setNewTitle: 'Defina uma nova senha',
  setNewPassword: 'Definir nova senha',
  passwordUpdated: 'Senha atualizada. Entre com sua nova senha.',

  yourAccount: 'Sua conta',
  signOut: 'Sair',
  changePicture: 'Alterar foto',
  uploading: 'Enviando…',
  preferredLanguage: 'Idioma preferido',
  saveChanges: 'Salvar alterações',
  saved: 'Salvo',
  passwordSection: 'Senha',
  changePassword: 'Alterar senha',

  adjustPhoto: 'Ajuste sua foto',
  cropHint: 'Arraste para reposicionar · use a rolagem ou pinça para ampliar.',
  savePhoto: 'Salvar foto',
  cropExportError: 'Não foi possível exportar a imagem recortada. Tente outra foto.',

  missingCode: 'Código de autorização ou verificador ausente',
  backToSignIn: 'Voltar para o login',
  signInFailed: 'Falha no login',

  signedOutTitle: 'Sessão terminada',
  signedOutBody: 'A sua sessão na conta WeApps foi terminada neste dispositivo.',
  goingBackIn: 'A voltar em {{n}}s…',
  returnToApp: 'Voltar',

  signingIn: 'A iniciar sessão…',
  signingInSubtitle: 'Só demora um instante.',

  // delete account (ISSUE-2026-07-20-240, ADR 0091)
  deleteTitle: 'Excluir sua conta',
  deleteIntro:
    'Você pode excluir sua conta WeApps aqui, pela web, sem abrir o aplicativo. Isso afeta sua conta em toda a plataforma.',
  deleteButton: 'Excluir conta',
  deleteConfirmTitle: 'Excluir sua conta permanentemente?',
  deleteConfirmBody:
    'Isso encerra seu acesso e remove sua conta em todas as organizações, grupos e cursos, em todos os dispositivos — seu login deixa de funcionar em qualquer lugar. Quando a lei exigir (por exemplo, registros financeiros de compras anteriores), alguns dados são mantidos de forma anonimizada. Esta ação é permanente e não pode ser desfeita.',
  deleteConfirmCta: 'Sim, excluir minha conta',
  deleteKeepCta: 'Manter minha conta',
  deleteError: 'Não foi possível agendar a exclusão. Tente novamente.',
  deleteDoneTitle: 'Conta agendada para exclusão',
  deleteDoneBody:
    'Sua conta foi agendada para exclusão e seu acesso está desativado. Não é mais possível entrar.',
  deleteDoneCta: 'Concluir',

  footer: 'Conta WeApps',
  language: 'Idioma',
  langEn: 'English',
  langPt: 'Português',
  langDe: 'Deutsch',
}
